import state from './state.loading'
import getters from './getters.loading'
import mutations from './mutations.loading'
import actions from './actions.loading'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}